import Factory from './utils/factory'

export default Factory({
  street: null,
  postcode: null,
  city: null,
  county: null,
  location: {
    type: 'Point',
    coordinates: null,
  },
})
